import React, { useContext, useState } from 'react'
import { ButtonBlue } from '../../Buttons/ButtonBlue'
import { CustomModal } from '../../CustomModal/CustomModal'
import { Spinner } from 'reactstrap'
import BuildingsManagementContext from '../../../context/BuildingManagementContext/BuildingsManagementContext'
import { t } from 'i18next'
import { getTenantInfoByKey, replaceExpecialCharacters } from '../../../helpers/helpers'
import buildingSuccessIcon from '../../../assets/icons/building-success-icon.svg';
import { useNavigate } from 'react-router-dom'
import errorIcon from '../../../assets/icons/triangule-exclamation.svg';

export const NameOfBuildings = () => {
  const navigate = useNavigate();
  const nameOfBuildings = getTenantInfoByKey('building_name');

  const { buildingsManagementState, changeNameOfBuildings, cleanBuildingState } = useContext(BuildingsManagementContext);
  const { isFetching, responseBuildingService } = buildingsManagementState;

  const initialState = {
    keyword: 'name_buildings',
    setting_value: nameOfBuildings
  }

  const [buildingNameState, setBuildingNameState] = useState(initialState);

  const disabled = !!!String(buildingNameState.setting_value).trim();

  const handleChange = (e) => {
    let { value, name } = e.target;
    setBuildingNameState({
      ...buildingNameState,
      [name]: replaceExpecialCharacters(value)
    })
  }

  const handleSubmit = async () => {
    if (disabled) return
    await changeNameOfBuildings(buildingNameState)
  }

  const closeWarningModal = async () => {
    await cleanBuildingState();
    navigate('/settings/params/nameOfEntities');
  }

  return (
    <div className='row justify-content-center w-100'>
      <div className=''>
        <div className='me-3 ms-3 mt-2'>

          <CustomModal showModal={responseBuildingService.show} centered={true} setShowModal={closeWarningModal}>
            <div className='d-flex flex-column align-items-center justify-content-center'>
              <img src={responseBuildingService.type === 'ERROR' ? errorIcon : buildingSuccessIcon} alt="" />
              <p className='mt-3 text-center param-section-title'>{responseBuildingService.text}</p>
              <p type="button" className='custom-modal-btn-ok' onClick={closeWarningModal}>{t('UNDERSTOOD')}</p>
            </div>
          </CustomModal>

          {isFetching ?
            <div className="d-flex mt-4 justify-content-center">
              <Spinner />
            </div>
            : null}

          <div>
            <p className='m-0 titlelabel-filter'>{t('DESCRIPTION')}</p>
            <p>
              <input
                className='form-control'
                type="text"
                name='setting_value'
                value={buildingNameState.setting_value}
                onChange={handleChange}
              />
            </p>
          </div>

          <div className='mt-3'>
            <div className='d-flex justify-content-around align-items-center mt-5 mb-4'>
              <div className=''>
                <p type='button' className='m-0' onClick={() => navigate(-1)}>{t('CANCEL')}</p>
              </div>

              <div className=''>
                <ButtonBlue onClick={handleSubmit} disabled={disabled}>
                  {t('SAVE')}
                </ButtonBlue>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}
